module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1fb625f77785de8fad61120e886b2b66.png";